/**
 * Chart feature switches. Flip to `false` to turn a feature off everywhere
 * (desktop + mobile) without touching the chart code.
 */
export const CHART_FEATURES = {
    // Shade night (sunset → sunrise, computed per station from its coordinates) behind the history charts.
    nightShading: true,
    // DARK THEME ONLY: series lines on all three history charts one to two Tailwind stops lighter
    // (--chart-*-line tokens). Light theme is unaffected either way.
    pastelLinesDark: true,
};
